import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatEUR(value, opts = {}) {
  if (value === null || value === undefined || value === "") return "—";
  const n = Number(value);
  if (Number.isNaN(n)) return "—";
  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: opts.decimals ?? 0,
    minimumFractionDigits: opts.decimals ?? 0,
  }).format(n);
}

export function formatEURSigned(value) {
  const n = Number(value || 0);
  const sign = n > 0 ? "+" : n < 0 ? "−" : "";
  return sign + formatEUR(Math.abs(n));
}

export function formatMoney(value, currency = "EUR", opts = {}) {
  if (value === null || value === undefined || value === "") return "—";
  const n = Number(value);
  if (Number.isNaN(n)) return "—";
  return new Intl.NumberFormat(currency === "USD" ? "en-US" : "fr-FR", {
    style: "currency",
    currency: currency || "EUR",
    maximumFractionDigits: opts.decimals ?? 0,
    minimumFractionDigits: opts.decimals ?? 0,
  }).format(n);
}

export function formatNumber(value) {
  if (value === null || value === undefined || value === "") return "—";
  return new Intl.NumberFormat("fr-FR").format(Number(value));
}

export function formatDate(value, locale = "fr-FR") {
  if (!value) return "—";
  try {
    return new Date(value).toLocaleDateString(locale, {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return value;
  }
}

export const ENTITY_COLORS = {
  holding: "#2563EB",
  consulting: "#10B981",
  ecommerce: "#EA580C",
  sci: "#F59E0B",
};
